var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileStaticImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.358 51.7819H157.091H34.909H29.671C23.2754 51.7819 18.0952 56.9891 18.0952 63.4182V161.891H173.934V63.4182C173.934 56.9891 168.754 51.7819 162.358 51.7819Z",
    fill: "#6E83FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.091 63.4182H34.9089H29.6709V150.255H162.358V63.4182H157.091Z",
    fill: "#2A2D6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28809 161.92C6.28809 175.098 16.9088 185.775 30.0184 185.775H161.982C175.092 185.775 185.712 175.098 185.712 161.92H6.28809Z",
    fill: "#6E83FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28809 161.92C6.28809 173.673 14.7384 183.418 25.8511 185.396C25.8222 185.367 25.7932 185.309 25.7643 185.28C21.1919 179.345 25.7064 170.676 33.1728 170.676H184.034C185.105 167.971 185.712 165.033 185.712 161.949H6.28809V161.92Z",
    fill: "#5A6CD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 6H156V29H35V6Z",
    fill: "#4EC4A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9808 20.9927C48.627 20.9927 49.9615 19.6512 49.9615 17.9964C49.9615 16.3415 48.627 15 46.9808 15C45.3345 15 44 16.3415 44 17.9964C44 19.6512 45.3345 20.9927 46.9808 20.9927Z",
    fill: "#17ADA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1673 20.9927C58.8135 20.9927 60.148 19.6512 60.148 17.9964C60.148 16.3415 58.8135 15 57.1673 15C55.5211 15 54.1865 16.3415 54.1865 17.9964C54.1865 19.6512 55.5211 20.9927 57.1673 20.9927Z",
    fill: "#17ADA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3543 20.9927C69.0005 20.9927 70.335 19.6512 70.335 17.9964C70.335 16.3415 69.0005 15 67.3543 15C65.7081 15 64.3735 16.3415 64.3735 17.9964C64.3735 19.6512 65.7081 20.9927 67.3543 20.9927Z",
    fill: "#17ADA4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35 29H156V134H35V29Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 71.9127L114.695 80.8727C109.891 76.0436 103.264 73.0763 96 73.0763V60.3927C106.794 60.4218 116.547 64.8145 123.608 71.9127Z",
    fill: "#00D2A3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M135.068 99.6654H122.451C122.451 92.3345 119.499 85.6727 114.695 80.8727L123.608 71.9127C130.698 79.04 135.068 88.8436 135.068 99.6654Z",
    fill: "#17ADA4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 60.4219V73.1055C88.7077 73.1055 82.0806 76.0728 77.2766 80.9019L68.3633 71.9419C75.4534 64.8146 85.206 60.4219 96.0004 60.4219Z",
    fill: "#00A5BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3055 80.8727C72.5305 85.6727 69.5497 92.3054 69.5497 99.6654H56.9321C56.9321 88.8436 61.302 79.04 68.3921 71.9127L77.3055 80.8727Z",
    fill: "#03C4DE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6785 100.887C96.9261 100.887 96.2026 100.596 95.6238 100.044C94.4952 98.9091 94.4952 97.0764 95.6238 95.9418L105.608 85.9055C106.737 84.7709 108.56 84.7709 109.688 85.9055C110.817 87.04 110.817 88.8727 109.688 90.0073L99.7043 100.044C99.1544 100.625 98.431 100.887 97.6785 100.887Z",
    fill: "#1F81A3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2217 43.8691H58.0604C56.4688 43.8691 55.1665 42.56 55.1665 40.96C55.1665 39.36 56.4688 38.0509 58.0604 38.0509H84.2217C85.8133 38.0509 87.1156 39.36 87.1156 40.96C87.1156 42.56 85.8133 43.8691 84.2217 43.8691Z",
    fill: "#AAB2BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6235 53.44H58.0604C56.4688 53.44 55.1665 52.1309 55.1665 50.5309C55.1665 48.9309 56.4688 47.6218 58.0604 47.6218H77.6235C79.2151 47.6218 80.5174 48.9309 80.5174 50.5309C80.5174 52.1309 79.2441 53.44 77.6235 53.44Z",
    fill: "#AAB2BD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2538 125.033C80.6621 125.033 79.3599 123.724 79.3599 122.124V116.509C79.3599 114.909 80.6621 113.6 82.2538 113.6C83.8455 113.6 85.1477 114.909 85.1477 116.509V122.124C85.1477 123.753 83.8744 125.033 82.2538 125.033Z",
    fill: "#AAB2BD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4276 125.033C89.836 125.033 88.5337 123.724 88.5337 122.124V116.509C88.5337 114.909 89.836 113.6 91.4276 113.6C93.0193 113.6 94.3216 114.909 94.3216 116.509V122.124C94.3216 123.753 93.0193 125.033 91.4276 125.033Z",
    fill: "#AAB2BD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.573 125.033C98.981 125.033 97.6787 123.724 97.6787 122.124V116.509C97.6787 114.909 98.981 113.6 100.573 113.6C102.164 113.6 103.467 114.909 103.467 116.509V122.124C103.467 123.753 102.164 125.033 100.573 125.033Z",
    fill: "#AAB2BD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.746 125.033C108.155 125.033 106.853 123.724 106.853 122.124V116.509C106.853 114.909 108.155 113.6 109.746 113.6C111.338 113.6 112.64 114.909 112.64 116.509V122.124C112.64 123.753 111.338 125.033 109.746 125.033Z",
    fill: "#AAB2BD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 106.385C99.6925 106.385 102.685 103.377 102.685 99.6654C102.685 95.9541 99.6925 92.9454 96.0004 92.9454C92.3084 92.9454 89.3154 95.9541 89.3154 99.6654C89.3154 103.377 92.3084 106.385 96.0004 106.385Z",
    fill: "#2C92BF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1995 93.3528C98.431 94.051 98.6046 94.7782 98.6046 95.5637C98.6046 99.2873 95.5949 102.284 91.9196 102.284C91.1382 102.284 90.4148 102.109 89.7202 101.876C90.6463 104.495 93.1061 106.386 96.0001 106.386C99.7043 106.386 102.685 103.36 102.685 99.6655C102.685 96.7273 100.804 94.2546 98.1995 93.3528Z",
    fill: "#1F81A3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.058 176.756H86.9711C85.3794 176.756 84.0771 175.447 84.0771 173.847C84.0771 172.247 85.3794 170.938 86.9711 170.938H105.058C106.65 170.938 107.952 172.247 107.952 173.847C107.952 175.447 106.65 176.756 105.058 176.756Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileStaticImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile_static_img.6723de3b0c05d58ae857f678572d6f9a.svg";